import axios from 'axios'
import { LISTAR_PONTOS_EMBARQUE_CIDADE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function listarPontosEmbarquePorEmpresaCidade(idEmpresa, idCidade) {
  const url = `${URL}/ponto-embarque/empresa/${idEmpresa}/cidade/${idCidade}`
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: LISTAR_PONTOS_EMBARQUE_CIDADE,
      payload: response
    })
  )
}
